import { render, staticRenderFns } from "./DetailPayment.vue?vue&type=template&id=36f03bfb"
import script from "./DetailPayment.vue?vue&type=script&lang=js"
export * from "./DetailPayment.vue?vue&type=script&lang=js"
import style0 from "./DetailPayment.vue?vue&type=style&index=0&id=36f03bfb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports